import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoginPage } from 'src/app/pages/login/login.page';
import { ConfigurationApiService } from 'src/app/services/configuration-api.service';
import { ModalHelperService } from 'src/app/services/modal-helper';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-action-details',
  templateUrl: './action-details.component.html',
  styleUrls: ['./action-details.component.scss'],
  standalone: false,
})
export class ActionDetailsComponent implements OnInit {
  @Input() modalType: string = '';
  @Input() configId: string = '';
  eConfigName: string = "";
  isFormValid = false;
  isSaving: boolean = false;
  saveError: string = '';
  storedProject: any;
  isNameExist: boolean = false;

  constructor(private modalController: ModalController, private storageService: StorageService,
    private modalHelper: ModalHelperService, private translate: TranslateService, private configApi: ConfigurationApiService, private loadingController: LoadingController,
    private router: Router) { }

  async ngOnInit() {
    console.log('Modal Type:', this.modalType);
    await this.init();
  }

  private async init(): Promise<void> {
    try {
      const res = await this.storageService.getProject();
      this.storedProject = res ? JSON.parse(res) : null;
      this.eConfigName = this.storedProject?.projectName ?? '';
      this.validateForm();
    } catch (error) {
      console.error('Error initializing spacer data:', error);
    }
  }

  validateForm(): void {
    // Check if required fields have values
    this.isFormValid = !!(this.eConfigName?.trim());
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  async next() {

    // this.storageService.updateProject({
    //   "projectName": this.eConfigName
    // });
    if (!this.isFormValid) return;
    let loader: HTMLIonLoadingElement | null = null;
    // always update projectName in storage first
    await this.storageService.updateProject({ projectName: this.eConfigName });

    if (this.modalType === 'rename' || this.modalType === 'save') {

      try {
        if (this.modalType === 'rename' && !this.storedProject?.id) {
          this.modalHelper.closeAllModals();
          return;
        }
        loader = await this.loadingController.create({
          message: this.translate.instant('wait'),
          spinner: 'crescent',
          backdropDismiss: false
        });
        await loader.present();
        this.isSaving = true;
        this.saveError = '';
        const oldProjectName = this.storedProject?.projectName;
        if (this.isNameExist && oldProjectName.trim() == this.eConfigName.trim())
          await this.configApi.saveConfiguration(this.eConfigName, true);
        else
          await this.configApi.saveConfiguration(this.eConfigName);
        this.modalHelper.closeAllModals();
      } catch (error: any) {
        console.error('Error saving configuration:', error);
        if (error.status === 409) {
          this.isNameExist = true;
        } else {
          this.saveError = error.message || 'Failed to save. Please try again.';

        }
      } finally {
        this.isSaving = false;
        if (loader) {
          await loader.dismiss().catch(() => { });
        }
      }
    } else {
      this.modalHelper.closeAllModals();
    }
  }
  async delete() {
    const res = await this.storageService.getProject();
    const p = res ? JSON.parse(res) : null;
    var projectId;
    if (this.configId && this.configId != '') {
      projectId = this.configId;
    } else {
      projectId = p?.id;
    }
    if (projectId) {
      let loader: HTMLIonLoadingElement | null = null;
      try {
        loader = await this.loadingController.create({
          message: this.translate.instant('please_wait'),
          spinner: 'crescent',
          backdropDismiss: false
        });
        await loader.present();
        this.isSaving = true;
        this.saveError = '';
        await this.configApi.deleteConfiguration().toPromise();
        // clear id from storage after successful delete
        await this.storageService.updateProject({ id: null });
        console.log('Configuration deleted successfully');
        this.router.navigate(['/tabs/landing']);
      } catch (error: any) {
        console.error('Error deleting configuration:', error);
        this.saveError = error.message || 'Failed to delete. Please try again.';
        this.isSaving = false;
        return; // don't close modals if delete failed
      } finally {
        this.isSaving = false;
        if (loader) {
          await loader.dismiss().catch(() => { });
        }
      }
    }

    this.modalHelper.closeAllModals();
  }

  async login() {
    const modal = await this.modalController.create({
      component: LoginPage,
      cssClass: 'configuration-modal'
    });
    await modal.present();
    await modal.onDidDismiss();
    this.modalHelper.closeAllModals();
  }

  close() {
    this.modalController.dismiss();
  }
}
